import React, { useState } from 'react'
import { ptBR } from 'date-fns/locale'
import DateFnsUtils from '@date-io/date-fns'
import * as Styles from './styles'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import Icon from '../icon'
import FormControl from '../form-control'
import InputLabel from '../input-label'
import GrayColorToken from '../../tokens/v2/colors/gray.palette'

type Props = {
  'data-qa'?: string
  autoFocus?: boolean
  disabled?: boolean
  hint?: string
  id?: string
  invalidDateMessage?: string
  label?: string
  maxDate?: Date | null
  maxDateMessage?: string
  minDate?: Date | null
  minDateMessage?: string
  name?: string
  placeholder?: string
  state?: 'active' | 'negative'
  value?: Date | null
  onBlur?: () => void
  onChange?: (date: Date, value?: string) => void
  style?: object
}

const DatePicker: React.FC<Props> = (props: Props): JSX.Element => {
  const [state, setState] = useState<Props['state']>(props.state || 'active')

  return (
    <FormControl>
      <InputLabel
        data-qa={`${props['data-qa']}-label`}
        htmlFor={props.id}
        text={props.label}
      />
      <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
        <Styles.DatePicker
          autoFocus={props.autoFocus}
          disableToolbar
          name={props.name}
          className={`${state || 'active'}`}
          data-qa={props['data-qa']}
          variant="inline"
          format="dd/MM/yyyy"
          margin="normal"
          placeholder={props.placeholder}
          maxDate={props.maxDate}
          minDate={props.minDate}
          id={props.id}
          value={props.value}
          inputVariant="outlined"
          disabled={props.disabled}
          onChange={props.onChange}
          onBlur={props.onBlur}
          keyboardIcon={<Icon name={'calendar_today'} />}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
          minDateMessage={props.minDateMessage || dateMessagesDefault.min}
          maxDateMessage={props.maxDateMessage || dateMessagesDefault.max}
          invalidDateMessage={
            props.invalidDateMessage || dateMessagesDefault.invalid
          }
          autoOk={true}
          onError={(error) => {
            if (error) {
              setState('negative')
              return
            }
            setState(props.state)
          }}
          style={props.style}
        ></Styles.DatePicker>
      </MuiPickersUtilsProvider>
      {props.hint && (
        <Styles.Hint
          className={`is-${props.state}`}
          data-qa={`${props['data-qa']}-hint`}
        >
          {props.hint}
        </Styles.Hint>
      )}
      <Styles.CalendarStyle />
    </FormControl>
  )
}

export default DatePicker

const dateMessagesDefault = {
  min: 'Data mínima inválida',
  max: 'Data máxima inválida',
  invalid: 'Data inválida',
}
